import React, { useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ResetPassword.scss';

const API_URL = process.env.REACT_APP_API_URL;

const ResetPassword = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const code = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.get('code') || '';
    }, [location.search]);

    const [status, setStatus] = useState('idle');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [error, setError] = useState('');

    const validate = () => {
        if (!code) return 'Brak tokenu resetowania hasła w linku.';
        if (password.length < 8) return 'Hasło musi mieć co najmniej 8 znaków.';
        if (password !== passwordConfirmation) return 'Hasła nie są identyczne.';
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationError = validate();
        if (validationError) {
            setError(validationError);
            setStatus('error');
            return;
        }

        setStatus('loading');
        setError('');

        try {
            const res = await fetch(`${API_URL}/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code,
                    password,
                    passwordConfirmation,
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(
                    data?.error?.message ||
                    data?.message ||
                    'Nie udało się zresetować hasła.'
                );
            }

            setStatus('success');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err.message || 'Nie udało się zresetować hasła.');
            setStatus('error');
        }
    };

    if (status === 'loading') {
        return <div>Resetowanie hasła...</div>;
    }

    if (status === 'success') {
        return (
            <div>
                Hasło zostało zmienione. Za chwilę nastąpi przekierowanie do logowania...
            </div>
        );
    }

    return (
        <div className="reset-password">
            <form onSubmit={handleSubmit} noValidate>
                <h2>Reset hasła</h2>

                <label>
                    Nowe hasło
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                    />
                </label>

                <label>
                    Potwierdź hasło
                    <input
                        type="password"
                        value={passwordConfirmation}
                        onChange={(e) => setPasswordConfirmation(e.target.value)}
                        autoComplete="new-password"
                        required
                    />
                </label>

                <button type="submit" disabled={status === 'loading'}>
                    Zmień hasło
                </button>

                {error && <div className="error-msg">{error}</div>}
            </form>
        </div>
    );
};

export default ResetPassword;